export const getMultiValue = (value) => {
  return typeof value === 'object' ? value.id : value;
};
